export enum EDITORIAL_TAB_TYPE {
  EPISODE_COLLECTION = 'episodeCollection',
  CLIP_COLLECTION = 'clipCollection',
  SERIES_COLLECTION = 'seriesCollection',
  MOVIE_COLLECTION = 'movieCollection'
}
